(function () {
    'use strict';

    angular
        .module('app.redirectUrls')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'redirectUrls',
                config: {
                    url: '/redirectUrls',
                    title: 'Yönlendirme Link',
                    abstract: true,
                    templateUrl: 'app/redirectUrls/redirectUrls.html'
                }
            },
            {
                state: 'redirectUrls.list',
                config: {
                    templateUrl: 'app/redirectUrls/redirectUrls.list.html',
                    controller: 'RedirectUrlsListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Yönlendirme Link Listesi',
                    settings: {
                        nav: 4,
                        name: 'redirectUrls.list',
                        topName: 'cms',
                        content: 'Yönlendirme Link Listesi',
                        resource: 'menu.redirectUrls.list'
                    }
                }
            }
        ];
    }
})();